module.exports = __webpack_public_path__ + "static/img/landing_dark.11a04f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/mergedom/landing_dark.png
// module id = ODph
// module chunks = 0